const socketRequest = (function() {

    // ATRIBUTOS PRIVADOS
    let socket = null;
    let socketRequestData = null;

    // METODOS PRIVADOS
    function socketErrors(errorCode, errorData) {

        switch(errorCode) {

            case 'DISCONNECTED_SOCKET':
                console.error('EL SOCKET NO ESTA CONECTADO');
                break;

            case 'ALREADY_CONNECTED':
                console.error('EL SOCKET YA SE ENCUENTRA CONECTADO');
                break;

            case 'REQUEST_DATA_ERROR':
                console.error('LOS DATOS PARA LA PETICION ' + errorData.requestName + ' NO SON CORRECTOS');
                break;

        }

    }

    function correctSocketRequestData(requestName, attributes) {

        let errorsDetected = false;

        if (!socket || !socket.connected) {
            socketErrors('DISCONNECTED_SOCKET');
            return false;
        }

        _.forEach(attributes, function(attribute) {
            if (attribute === null || attribute === undefined) {
                socketErrors('REQUEST_DATA_ERROR', {requestName: requestName});
                errorsDetected = true;
            }
        });

        return errorsDetected === false;

    }

    // METODOS PUBLICOS
    return {

        // OPCIONES DEL SOCKET ==================================================================================================== //
        connect: function(query = '') {

            // TODO Temporal, cuando esten todos aqui no se usara el de notificationSistem
            socket = notificationSystem.getSocket();
            /*if (!socket) {
                socket = query.length > 0 ? io.connect(node_url, {query: query}) : io.connect(node_url);
            } else {
                socketErrors('ALREADY_CONNECTED');
            }*/

        },

        disconnect: function() {
            socket = null;
        },

        getSocket: function() {
            return socket;
        },

        // SERVICIOS DEL SOCKET =================================================================================================== //

        // CHAT =================================================================================================================== //
        changeRoomStatus: function(inRoomScreen, roomId) {

            socketRequestData = {
                in_room_screen: inRoomScreen,
                room_id: roomId
            }

            if (correctSocketRequestData('CHANGE_ROOM_STATUS_REQUEST', [inRoomScreen, roomId])) {
                socket.emit(SocketEvents.CHANGE_ROOM_STATUS_REQUEST(), JSON.stringify(socketRequestData));
            }

        },

        sendMessage: function(payload, messageType, roomId, userId, isSupport) {

            socketRequestData = {
                message: {
                    type: messageType,
                    payload: payload
                },
            }

            if (roomId) {
                socketRequestData.room_id = roomId;
            }

            if (userId) {
                socketRequestData.user_id = userId;
            }

            if (isSupport) {
                socketRequestData.is_support = 1;
            }

            if (correctSocketRequestData('SEND_MESSAGE_REQUEST', [payload, messageType, roomId ? roomId : userId])) {
                socket.emit(SocketEvents.SEND_MESSAGE_REQUEST(), JSON.stringify(socketRequestData));
            }

        },

        notifyMessageReceived: function(messageId) {

            socketRequestData = {
                message_id: messageId,
                receive_date: Math.floor(new Date().getTime() / 1000)
            }

            if (correctSocketRequestData('NOTIFY_MESSAGE_RECEIVED_REQUEST', [messageId])) {
                socket.emit(SocketEvents.NOTIFY_MESSAGE_RECEIVED_REQUEST(), JSON.stringify(socketRequestData));
            }

        }

        // CHART ================================================================================================================== //
        // JUEGO ================================================================================================================== //
        // DOCUMENTACION ========================================================================================================== //

    }

})();